import HSContinousBar from './hs-continous-bar';

export default HSContinousBar;
